import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import 'rxjs/add/operator/map';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'; //, ModalDismissReasons
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Meta, Title } from '@angular/platform-browser';
import { Observable } from 'rxjs/Rx';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { retry } from 'rxjs/operators';

//*PROVIDER *//
import { UserProvider } from '../user/user';

@Injectable()
export class BasicProvider {


  public httpUrl = '';
  public imgUrl = "";
  public webimgUrl = "";
  public webUrl = "";
  public validation_msg = {};
  public validation_error = "";
  public loading;
  public alert;
  public device_type = 'web';
  public device_token = '';
  public alertTitle = 'Dash Express';
  public formLock: boolean = false;
  public commonData;
  public model: any;
  public model_type;
  public message = "Dash Express";
  public data;
  public defaultImage;
  public offset;

  //Menu collepse clsss
  public menu_type = 'menu_hide'; //menu_show menu_hide
  public cantainer_class; //remove_sidebar1
  public side_class; //sidebarcolleps
  public logohide_class; //divHide
  public divhide_class; //divHide
  public menuhide_class; //menuTextHide

  public temp_id; //menuTextHide

  public ISTESTMODE: boolean = false;
  public PRO_MODE: string = '';
  public AWS_S3_BUCKET_URL="https://dashexpress.s3.us-east-2.amazonaws.com";
  // public SUBFOLDER_NAME="dashexpress_demo/";
  public SUBFOLDER_NAME="";
  constructor(
    private titleService: Title,
    private metaService: Meta,
    public http: Http,
    public up: UserProvider,
    private spinnerService: Ng4LoadingSpinnerService,
    public httpClient: HttpClient,
    private toastr: ToastrService,
  ) {

    this.defaultImage = "";
    this.PRO_MODE = 'LIVE';
    if (this.PRO_MODE == 'LOCAL' ) {
      //console.log('Test mode is running.');
      this.httpUrl = "https://mymeetingdesk.com:5005/";
      this.webUrl = "http://192.168.0.84/dashexpress/";
      this.imgUrl = "http://192.168.0.84/dashexpress/public/uploads/";
      this.webimgUrl = "http://192.168.0.84/dashexpress/dist/assets/img/";
    } else if(this.PRO_MODE == 'DEMO') {
      //console.log('Demo mode is running.');
      this.httpUrl = "http://3.138.52.2:7702/"
      this.webUrl = "http://3.138.52.2/dashexpress_demo/";
      this.imgUrl = "http://3.138.52.2/dashexpress_demo/public/uploads/";
      this.webimgUrl = "http://3.138.52.2/dashexpress_demo/assets/img/";
    } else { // LIVE
     this.httpUrl = "https://dashexpressintl.com:8076/"
    //  this.httpUrl = "https://mymeetingdesk.com:5005/";
     this.webUrl = "https://dashexpressintl.com/";
     this.imgUrl = "https://dashexpressintl.com/public/uploads/";
     this.webimgUrl = "https://dashexpressintl.com/assets/img/";
    }

    this.offset = "100";
    this.validation_error = "";
    this.validation_msg = {
      'required': ' is required.',
      'pattern': ' not having valid pattern.',
      'minlength': ' not having min length',
      'maxlength': ' not having max length'
    };
  }

  // Toast function
  show_toast(type='', msg='', title='') {
    if (type=='Success') {
      this.toastr.success(msg, title);
    } else if(type=='Error') {
      this.toastr.error(msg, title);
    } else if(type=='Info') {
      this.toastr.info(msg, title);
    } else if(type=='Warning') {
      this.toastr.warning(msg, title);
    }
  }

  //Form lock Activate
  public activateLock() {
    this.formLock = true;
  }

  //Form lock Deactivate
  public deactivateLock() {
    this.formLock = false;
  }

  //Show General alert
  public showAlert(message, buttontxt = "OK", handler = () => {
  }, cancelButton: any = "", cancelHandler = () => {
  }, title = this.alertTitle) {
    let buttonsArr = [{
      text: buttontxt,
      handler: handler,
      cssClass: 'button-ios-orange1'
    }];

    if (cancelButton != "") {
      buttonsArr.push({
        text: cancelButton,
        handler: cancelHandler,
        cssClass: 'button-ios-orange1'
      });
    }
    message = message.replace(new RegExp('_', 'g'), " ");
    message = message.charAt(0).toUpperCase() + message.substr(1)
    //alert(message);
    this.message = message;
    this.open(message);
  }

  // Validation
  public validation(form, msg: any = '') {
    if (form.valid) {
      return true;
    }
    outer: for (const field in form.controls) {
      //window.scrollTo(0, 0)
      const control = form.get(field);
      if (control && (control.dirty || !control.valid)) {
        if (msg && msg[field]) {
          const messages = msg[field];
          for (const key in control.errors) {
            if (messages[key]) {
              this.validation_error = this.getTranslate(messages[key]);
              this.validation_error = this.validation_error.replace(new RegExp('_', 'g'), " ");
              this.validation_error = this.validation_error.charAt(0).toUpperCase() + this.validation_error.substr(1)
              //this.showAlert(messages[key]);
            } else {
              if (this.validation_msg[key]) {
                //this.showAlert(field + this.validation_msg[key]);
                this.validation_error = this.getTranslate(field + this.validation_msg[key]);
                this.validation_error = this.validation_error.replace(new RegExp('_', 'g'), " ");
                this.validation_error = this.validation_error.charAt(0).toUpperCase() + this.validation_error.substr(1)
              } else {
                //this.showAlert('Field have error:- ' + key);
                this.validation_error = this.getTranslate('Field have error:- ' + key);
                this.validation_error = this.validation_error.replace(new RegExp('_', 'g'), " ");
                this.validation_error = this.validation_error.charAt(0).toUpperCase() + this.validation_error.substr(1)
              }
            }
            break outer;
          }
        } else {
          for (const key in control.errors) {
            const messages = this.validation_msg[key];
            if (messages) {
              //this.showAlert(field + messages);
              this.validation_error = this.getTranslate(field + messages);
              this.validation_error = this.validation_error.replace(new RegExp('_', 'g'), " ");
              this.validation_error = this.validation_error.charAt(0).toUpperCase() + this.validation_error.substr(1)
            } else {
              //this.showAlert('Field have error:- ' + key);
              this.validation_error = this.getTranslate('Field have error:- ' + key);
              this.validation_error = this.validation_error.replace(new RegExp('_', 'g'), " ");
              this.validation_error = this.validation_error.charAt(0).toUpperCase() + this.validation_error.substr(1)
            }
            break outer;
          }
        }
      }

    }
  }

  required(control: FormControl) {
    let inputValue = control.value ? control.value.toString() : '';
    inputValue = inputValue.replace(/^\s+|\s+$/g, ''); // trim input

    if (!inputValue) {
      return {
        required: {
          actualValue: control.value,
          valid: false
        }
      };
    }
  }

  // Show loader
  public showLoader(content = '') {
    this.spinnerService.show();
  }

  // Hide Loader
  public hideLoader() {
    this.spinnerService.hide();
  }

  //Create Request Header
  public createRequestOptions() {
    let header = new Headers();
    header.append("app-version", "1.3");
    header.append("os", "web");
    header.append("content-type", "application/json");
    //console.log('up data - ',this.up);
    if (this.up.sid != "" && this.up != undefined) {
      header.append("sid", this.up.sid);
    }
    let options = new RequestOptions({ headers: header });
    return options;
  }

  //Get data from server
  public hitApi(url: string, method: string, data, loader = true, header: boolean = false) {
    if (!this.formLock) {
      this.activateLock();
      if (loader == true) {
        this.showLoader();
      }

      let options: RequestOptions;
      if (header) {
        options = this.createRequestOptions();
      }
      if (method == 'POST') {
        return this.http.post(this.httpUrl + url, data, options)
          .map((res: Response) => this.successAPI(res))
          .catch((error: any) => this.errorAPI(error));
      } else if (method == 'GET') {
        return this.http.get(this.httpUrl + url + "?" + this.toQueryString(data), options)
          .map((res: Response) => this.successAPI(res))
          .catch((error: any) => this.errorAPI(error));
      } else if (method == 'DELETE') {
        return this.http.delete(this.httpUrl + url + "?" + this.toQueryString(data), options)
          .map((res: Response) => this.successAPI(res))
          .catch((error: any) => this.errorAPI(error));
      }
    }
  }


  public upload(url, data, contentType?: string, reportProgress = false): any {
    const options: any = {
      reportProgress: false,
      headers: {
        'Cache-Control': 'public, max-age=31536000',
      },
    };

    let uploadData = data;
    if (!reportProgress) {
      return this.httpClient.put(url, uploadData, options).pipe(retry(3));
    } else {
      return this.httpClient.request( new HttpRequest('PUT', url, uploadData, {
          reportProgress: true,
          headers: new HttpHeaders(options.headers),
        }) );
    }
  }

  public hitApiHeader(url: string, method: string, data, loader = true, header: any = '') {
    if (!this.formLock) {
      this.activateLock();
      if (loader == true) {
        this.showLoader();
      }

      let options: RequestOptions;
      options = header;
      console.log('options'+options);
      if (method == 'POST') {
        return this.http.post(this.httpUrl + url, data, options)
          .map((res: Response) => this.successAPI(res))
          .catch((error: any) => this.errorAPI(error));
      } else if (method == 'GET') {
        return this.http.get(this.httpUrl + url + "?" + this.toQueryString(data), options)
          .map((res: Response) => this.successAPI(res))
          .catch((error: any) => this.errorAPI(error));
      }
    }
  }

  //Success Server Data
  public successAPI(res) {
    this.deactivateLock();
    this.hideLoader();
    return res.json();
  }

  //Error Server Data
  public errorAPI(error): Observable<any> {
    this.deactivateLock();
    this.hideLoader();
    console.log(error);
    console.log(JSON.stringify(error));
    if (error.status == 400) {
      return Observable.throw(400);
    } else if (error.status == 0) {
      this.showAlert('Network not found, Please check your connection.', 'OK', () => {
        return Observable.throw('Network not found, Please check your connection.');
      });
    } else {
      error = error.json();
      return Observable.throw(error.error || this.showAlert((error.replyMsg ? error.replyMsg : 'Server Error')));
    }
  }

  //Conver Data to query string
  public toQueryString(obj) {
    var parts = [];
    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        parts.push(encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]));
      }
    }
    return parts.join("&");
  }


  postProfileImage(fileToUpload: File): Observable<any> {
    const endpoint = this.httpUrl + "users/profile_image";
    const formData: FormData = new FormData();
    formData.append('image', fileToUpload, fileToUpload.name);
    let header = new HttpHeaders();
    let other_header = header.append('app-version', '1.0');
    other_header = other_header.append('os', 'ios');
    if (this.up.sid != "" && this.up != undefined) {
      other_header = other_header.append("sid", this.up.sid);
    }
    return this.httpClient
      .post(endpoint, formData, { headers: other_header })
      .map((res: Response) => res)
      .catch((error: any) => this.errorAPI(error));
  }

  //Upload image of profile
  postFile(fileToUpload: File, type): Observable<any> {
    const endpoint = this.httpUrl + "users/verify_images";
    const formData: FormData = new FormData();
    formData.append('image', fileToUpload, fileToUpload.name);
    let header = new HttpHeaders();
    let other_header = header.append('app-version', '1.0');
    other_header = other_header.append('os', 'ios');
    other_header = other_header.append('type', type);
    if (this.up.sid != "" && this.up != undefined) {
      other_header = other_header.append("sid", this.up.sid);
    }
    return this.httpClient
      .post(endpoint, formData, { headers: other_header })
      .map((res: Response) => res)
      .catch((error: any) => this.errorAPI(error));
  }

  //Get image
  public getImage(imgName: string, type: string) {
    switch (type) {
      case 'user':
        return (imgName != '' && imgName != null) ? (this.imgUrl + 'users/' + imgName) : './assets/img/noimage.png';
      case 'loading':
        return (imgName != '' && imgName != null) ? (this.imgUrl + '' + imgName) : '';
      default:
        return (imgName != '' && imgName != null) ? (this.imgUrl + 'users/' + imgName) : './assets/img/noimage.png';
    }
  }


  //Updaet Profile
  public getUserProfileImage(imgName: string, type: string) {
    switch (type) {
      case 'user':
        return (imgName != '' && imgName != null) ? `${this.AWS_S3_BUCKET_URL}/${imgName}` : './assets/img/noimage.png';
      case 'loading':
        return (imgName != '' && imgName != null) ? (this.imgUrl + '' + imgName) : '';
      default:
        return (imgName != '' && imgName != null) ? (this.imgUrl + 'users/' + imgName) : './assets/img/noimage.png';
    }
  }

   //Updaet Profile
   public getUserProfileSign(imgName: string, type: string) {
    switch (type) {
      case 'user':
        return (imgName != '' && imgName != null) ? `${this.AWS_S3_BUCKET_URL}/${imgName}` : './assets/img/noimage.png';
      case 'loading':
        return (imgName != '' && imgName != null) ? (this.imgUrl + '' + imgName) : '';
      default:
        return (imgName != '' && imgName != null) ? (this.imgUrl + 'users/' + imgName) : './assets/img/noimage.png';
    }
  }


  public getInvoice(imgName: string, type: string) {
    switch (type) {
      case 'invoice':
        return (imgName != '' && imgName != null) ? `${imgName}` : './assets/img/';
      case 'loading':
        return (imgName != '' && imgName != null) ? (this.imgUrl + '' + imgName) : '';
      default:
        return (imgName != '' && imgName != null) ? (this.imgUrl + 'invoice/' + imgName) : './assets/img/noimage1.png';
    }
  }

  //Get Common Data
  public getCommonData() {
    this.hitApi('items/allfilters', 'GET', {}, false, true).subscribe(
      success => {
        if (success.type) {
          this.commonData = success.data;
        } else {
          this.showAlert(success.message);
        }
      }, error => console.log(error)
    )
  }

  public getTotalPrice(price, commision, discount, quantity = 1) {
    price = parseInt(price);
    commision = parseInt(commision);
    discount = parseInt(discount);
    let calCommision = this.getCommisionPrice(price, commision, quantity);
    return ((price + calCommision - discount) * quantity);
  }

  public getCommisionPrice(price, commision, quantity) {
    return (Math.ceil((price * commision) / 100)) * quantity;
  }

  public getCardType(number) {
    // visa
    var re = new RegExp("^4");
    if (number.match(re) != null)
      return "visa";

    // Mastercard
    if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number))
      return "mastercard";

    // AMEX
    re = new RegExp("^3[47]");
    if (number.match(re) != null)
      return "amex";

    // Discover
    re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
    if (number.match(re) != null)
      return "discover";

    // Diners
    re = new RegExp("^36");
    if (number.match(re) != null)
      return "Diners";

    // Diners - Carte Blanche
    re = new RegExp("^30[0-5]");
    if (number.match(re) != null)
      return "Diners - Carte Blanche";

    // JCB
    re = new RegExp("^35(2[89]|[3-8][0-9])");
    if (number.match(re) != null)
      return "jcb";

    // Visa Electron
    re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
    if (number.match(re) != null)
      return "Visa Electron";

    return "";
  }


  /*
   * Check Image exist
   */
  // public imageExist (url) {
  //   return new Promise((resolve, reject) => {
  //     var img = new Image();
  //     img.onload = function () { resolve(true); };
  //     img.onerror = function () { reject(false); };
  //     img.src = url;
  //   })
  // }

  //********LOCALSTORAGE************** */
  set(key, value) {
    window.localStorage[key] = value;
  }

  get(key, defaultValue) {
    return window.localStorage[key] || defaultValue;
  }

  setObject(key, value) {
    window.localStorage[key] = JSON.stringify(value);
  }

  getObject(key) {
    return JSON.parse(window.localStorage[key] || '{}');
  }

  removeItem(key) {
    window.localStorage.removeItem(key);
  }

  removeByIndex(index) {
    window.localStorage.removeItem(window.localStorage.key(index));
  }

  clear() {
    window.localStorage.clear();
  }

  //********LOCALSTORAGE************* */
  //************** Change Language  */
  getTranslate(str) {
    return str;//this.translate.instant(str);
  }

  gt(str) {
    return str;//this.translate.instant(str);
  }

  setLanguage(language) {
    this.hideMenu(2);
    this.set("language", language);
    //this.translate.use(language);
  }
  //************** Change Language  */

  //***************Confirm box */
  confirm(message?: string): Observable<boolean> {
    const confirmation = window.confirm(message || 'Is it OK?');
    return Observable.of(confirmation);
  };

  //***************Set fix and/remove fix header */
  addFixHeader() {
    document.getElementById("mega-menu").classList.remove('show');
    window.scrollTo(0, 0);
    document.getElementById("header").classList.add('fixheader');
  }

  removeFixHeader() {
    document.getElementById("mega-menu").classList.remove('show');
    window.scrollTo(0, 0);
    document.getElementById("header").classList.remove('fixheader');
  }

  //****************NgBootstrap Model */
  close() {
    if (this.model != undefined)
      this.model.close();
  }

  open(title, redirect = "", data = {}, button1 = "Ok", button2 = "") {
    /*this.close();
    this.model = this.modalService.open(ModalComponent, { windowClass: 'signup-modal' });
    this.model.componentInstance.title = title;
    this.model.componentInstance.model = this.model;
    this.model.componentInstance.redirect = redirect;
    this.model.componentInstance.data = data;
    this.model.componentInstance.button1 = button1;
    this.model.componentInstance.button2 = button2;
    */
  }
  //****************NgBootstrap Model */
  //****************Pass parametars */
  setData(value) {
    this.data = value;
  }

  getData(defaultValue = '') {
    return this.data || defaultValue;
  }

  setObjectData(value) {
    this.data = JSON.stringify(value);
  }

  getObjectData() {
    return JSON.parse(this.data || '{}');
  }
  //****************Pass parametars */

  //****************Hime mobile menu */
  public hideMenu(number) {
    document.getElementById("voudoo-menu").classList.remove('show');
  }

  //****************SEO******** */
  public updateTag(tags) {
    tags.forEach(element => {
      this.metaService.updateTag({ content: element.content }, element.property);
    })
  }
  public setTitle(title) {
    title = title.replace(new RegExp('_', 'g'), " ");
    this.titleService.setTitle("Dash Express " + title);
  }
  //****************SEO******** */


  between(x, min, max) {
    //console.log('x = '+x+' min = '+min+' max = '+max);
    //console.log( x >= min);
    //console.log( x <= max);
    return x >= min && x <= max;
  }

  /*
     * hitApi
     * @params:- url (api url), method (GET or POST), data (Post data), loader (loader is shown or not)
     * Example:- hitApi('login', 'POST');
     */
    public paypalApi(url: string, method: string, data = {}, loader: boolean = true, token) {
      let header = new Headers();
      header.append("Content-Type", "application/json; charset=utf-8");
      header.append("Authorization", 'Bearer '+token);
      let options = new RequestOptions({ headers: header });

      if (!this.formLock) {
        this.activateLock();
        if (loader == true) {
            this.showLoader();
        }

        if (method == 'POST') {
            return this.http.post( url, data, options)
            .map((res: Response) => this.successAPI(res))
            .catch((error: any) => this.errorAPIPaypal(error));
        }
        else if (method == 'GET') {
            return this.http.get( url  + this.toQueryString(data),options)
            .map((res: Response) => this.successAPI(res))
            .catch((error: any) => this.errorAPIPaypal(error));
        }
        else if (method == 'DELETE') {
            return this.http.delete( url  + this.toQueryString(data),options)
            .map((res: Response) => this.successAPI(res))
            .catch((error: any) => this.errorAPIPaypal(error));
        }
    }
  }

  public errorAPIPaypal(error): Observable<any> {
      this.deactivateLock();
      this.hideLoader();
      if (error.status == 404) {
          //this.showAlert((error.name ? 'Please check card details' : 'Server Error'), 'OK' )
          let error_msg = error.name ? 'There is some error, Please check card details' : 'Server Error';
          this.show_toast('Error',error_msg);
          return Observable.throw("Api Not Found.");
      } else if (error.status == 0) {
          let error_msg = 'Network not found, Please check your connection.';
          this.show_toast('Error',error_msg);
          return Observable.throw(error_msg);
      } else {
          error = error.json();
          switch (error.cmd) {
              case 'login_secure':
                  return Observable.throw(error.message);
              default:
                  let error_msg = error.name ? 'There is some error, Please check card details' : 'Server Error';
                  this.show_toast('Error',error_msg);
                  return Observable.throw(error.message);
          }
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/providers/basic/basic.ts